var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7739 11.3217C30.3376 12.1243 29.6657 13.1042 28.6849 13.1042H4.24998C3.46758 13.1042 2.83331 12.4699 2.83331 11.6875V9.09501C2.83331 5.63834 5.63831 2.83334 9.09498 2.83334H12.3816C14.6908 2.83334 15.4133 3.58418 16.3341 4.81668L18.3175 7.45168C18.7566 8.03251 18.8133 8.10334 19.635 8.10334H23.5875C26.144 8.10334 28.4064 9.37422 29.7739 11.3217Z",
    fill: "#3C3D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1431 16.641C31.1404 15.8606 30.5069 15.2292 29.7265 15.2292H4.24998C3.46758 15.2292 2.83331 15.8634 2.83331 16.6458V23.5875C2.83331 27.7667 6.23331 31.1667 10.4125 31.1667H23.5875C27.7666 31.1667 31.1666 27.7667 31.1666 23.5875L31.1431 16.641ZM20.5983 24.0408L17.5525 26.7042C17.3966 26.8458 17.1983 26.9167 17 26.9167C16.8016 26.9167 16.6033 26.8458 16.4475 26.7042L13.4016 24.0408C12.4383 23.1908 12.3108 21.7458 13.1183 20.74C13.9258 19.72 15.385 19.5358 16.4333 20.315L17 20.74L17.5666 20.315C18.615 19.5358 20.0741 19.72 20.8816 20.74C21.6891 21.7458 21.5616 23.1908 20.5983 24.0408Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFavorite);
export default __webpack_public_path__ + "static/media/folder-favorite.f3964835bb158cb8b854cbf84455191f.svg";
export { ForwardRef as ReactComponent };